import { ajax } from '@/api/ajax';
import type { TQueryFileInfoParams } from '@/api/queryFileInfo';
import {
  AppCode,
  type DownloadFileQueryVO,
  type DownloadFileVO,
  type GenerateSignedUrlParams,
  type SignedUrlResponse
} from '@xpeng/xdragon-ass-components-eu/es/api/baseService/file';

// 保存附件信息，返回fileId
export function saveFileInfo(data: {
  billId?: string;
  url: string;
  useFileTime?: number;
  waterMark?: number;
  waterMarkText?: string;
}) {
  return ajax({
    url: '/api/tis/web/epc/common/eapSysAttachment/saveFileInfo',
    method: 'post',
    data: data
  });
}
// 根据fileId获取附件信息
export function queryFileInfoApi(p: TQueryFileInfoParams) {
  return ajax({
    url: '/api/tis/web/epc/common/eapSysAttachment/listByFileIds',
    method: 'post',
    data: p
  });
}

// 获取OSS上传下载地址
export function getUploadUrl(data) {
  return ajax<{ uploadUrl: string; downloadUrl: string }>({
    url: '/api/tis/web/epc/common/file/getUploadUrl',
    method: 'post',
    data
  });
}

// 批量获取OSS上传下载地址
export function batchGetUploadUrl(fileNames: string[]) {
  return ajax<{ uploadUrl: string; downloadUrl: string }[]>({
    url: '/api/tis/web/epc/common/file/batchGetUploadUrl',
    method: 'post',
    data: { fileNames }
  });
}

/**
 * 生成预签名上传URL
 * 接口地址：
 * http://logan-gateway.test.logan.xiaopeng.local/xp-dragon-base-service-boot/doc.html#/%E4%BB%85%E7%AE%A1%E7%90%86%E5%90%8E%E5%8F%B0%E4%B8%93%E7%94%A8%E6%8E%A5%E5%8F%A3%E6%96%87%E6%A1%A3/%E6%96%87%E4%BB%B6%E6%93%8D%E4%BD%9C%E6%9C%8D%E5%8A%A1/generateSignedUrlUsingPOST
 */
export function generateSignedUrl(data: GenerateSignedUrlParams = {}) {
  return ajax<SignedUrlResponse>({
    url: '/api/service/v1/file/operate/generateSignedUrl',
    method: 'post',
    data: {
      appCode: AppCode.ass,
      ...data
    }
  });
}

/**
 * 批量下载
 * 接口地址：
 * http://logan-gateway.test.logan.xiaopeng.local/xp-dragon-base-service-boot/doc.html#/%E4%BB%85%E7%AE%A1%E7%90%86%E5%90%8E%E5%8F%B0%E4%B8%93%E7%94%A8%E6%8E%A5%E5%8F%A3%E6%96%87%E6%A1%A3/%E6%96%87%E4%BB%B6%E6%93%8D%E4%BD%9C%E6%9C%8D%E5%8A%A1/batchDownloadUsingPOST
 * 文件id，fileId，fileUrl，objectKey 需至少一个不为空，优先级 fileId>fileUrl>objectKey
 */
export function batchDownload(data: DownloadFileQueryVO[]) {
  return ajax<DownloadFileVO[]>({
    url: '/api/service/v1/file/operate/batchDownload',
    method: 'post',
    data
  });
}
